import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useEffect, useRef} from "../_snowpack/pkg/react.js";
import {getUrl} from "../common/universal.js";
import {Routes} from "../typings/routes.js";
import {colors} from "./theme.js";
import {TransformWrapper, TransformComponent} from "../_snowpack/pkg/react-zoom-pan-pinch.js";
export default function SimpleEditor(props) {
  const {
    outsideTexturePath,
    productSlug,
    backgroundColor,
    model_image,
    transformations,
    ...rest
  } = props;
  const textureUrl = getUrl(Routes.editorGetTransformed, {}, {
    query: {
      path: outsideTexturePath,
      slug: productSlug
    }
  });
  const backgroundUrl = model_image.filename;
  const canvasRef = useRef(null);
  async function draw() {
    const canvas = canvasRef.current;
    if (!canvas)
      return;
    const backgroundImg = await loadImage(backgroundUrl);
    const textureImg = outsideTexturePath ? await loadImage(textureUrl) : void 0;
    drawBackground(canvas, backgroundImg);
    textureImg && drawTexture(canvas, textureImg, transformations);
  }
  useEffect(() => {
    draw();
  }, [outsideTexturePath]);
  return /* @__PURE__ */ React.createElement(Container, {
    style: {"--backgroundColor": backgroundColor + "70"},
    ...rest
  }, /* @__PURE__ */ React.createElement(TransformWrapper, null, /* @__PURE__ */ React.createElement(TransformComponent, null, /* @__PURE__ */ React.createElement(CanvasContainer, null, /* @__PURE__ */ React.createElement(Canvas, {
    ref: canvasRef
  })))));
}
function drawBackground(canvas, img) {
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  if (!ctx)
    return;
  ctx.globalCompositeOperation = "multiply";
  ctx.drawImage(img, 0, 0, img.width, img.height);
}
function drawTexture(canvas, img, transformations) {
  const ctx = canvas.getContext("2d");
  if (!ctx)
    return;
  const [transformation] = transformations;
  const {top, left, width, height} = transformation;
  ctx.drawImage(img, 0, 0, img.width, img.height, left, top, width, height);
}
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
const Container = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${colors.b4};

  .react-transform-wrapper,
  .react-transform-component {
    width: 100%;
    height: 100%;
  }

  .react-transform-component {
    background: white;
  }
`;
const CanvasContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: var(--backgroundColor);
`;
const Canvas = styled.canvas`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
